import { useEffect, useRef, useState } from "react";
import { fetchBuilderRunSummary } from "./api/builderResultsApi";

export default function useBuilderRunSummary({ builderId, runId, isVisible }) {
  const key = `${builderId}:${runId}`;
  const cacheRef = useRef({ key: "", data: null });
  const [state, setState] = useState({ key: "", data: null, loading: false, error: "" });

  useEffect(() => {
    if (!builderId || !runId || !isVisible) return undefined;
    const controller = new AbortController();
    if (cacheRef.current.key === key && cacheRef.current.data) {
      setState({ key, data: cacheRef.current.data, loading: false, error: "" });
      return () => controller.abort();
    }
    setState({ key, data: null, loading: true, error: "" });
    fetchBuilderRunSummary(builderId, runId, controller.signal)
      .then((data) => {
        if (controller.signal.aborted) return;
        cacheRef.current = { key, data };
        setState({ key, data, loading: false, error: "" });
      })
      .catch((error) => {
        if (!controller.signal.aborted) setState({ key, data: null, loading: false, error: String(error?.message || error) });
      });
    return () => controller.abort();
  }, [builderId, runId, key, isVisible]);

  return state.key === key ? state : { data: null, loading: !!runId, error: "" };
}
